import React from "react";
import ReactDOM from "react-dom/client";
import "./main.scss";
import App from "./App";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { CookiesProvider } from "react-cookie";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
const queryClient = new QueryClient();

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
    <QueryClientProvider client={queryClient}>
        <CookiesProvider>
            <RecoilRoot>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </RecoilRoot>
        </CookiesProvider>
    </QueryClientProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
